import React, { useState } from "react";

const Dropdown = ({
  options,
  selected,
  setSelected,
  placeHolder,
  title,
  multiSelect = false,
  className,
  valueToShow,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const checkItemExists = (newItem) => {
    const exists = selected.some((item) => item.name === newItem.name);
    return exists;
  };

  // Find the "All Category" option if it exists
  const allCategoryOption = options.find(
    (option) => option.name === `All ${title}`
  );

  return (
    <div className={`relative w-64 ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between pl-4 pr-2 w-62 h-12 rounded-full text-gray-700 border border-gray-300 bg-[#F7F7F7]"
      >
        <p className="text-[#0A2D67] truncate ...">
          <span className="font-medium">{title} : </span>
          <span className="font-bold">
            {valueToShow ??
              (selected.length > 0 && multiSelect
                ? selected.length === options.length ||
                  selected.some((item) => item.name === `All ${title}`)
                  ? `All ${title}`
                  : `${selected.length} selected`
                : selected.name
                ? selected.name
                : placeHolder)}
          </span>
        </p>

        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
        >
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </button>

      {isOpen && (
        <div className="absolute w-full mt-2 bg-white border border-gray-300 rounded-2xl shadow-lg z-10">
          {multiSelect && (
            <div className="p-4 border-b border-gray-200 flex justify-between">
              <span className="text-[#0A2D67] text-xs font-bold">
                Select by {title}
              </span>
              <button
                onClick={() => {
                  setSelected([]);
                  setIsOpen(false);
                }}
                className="text-xs text-[#D05354] font-semibold underline"
              >
                Clear All
              </button>
            </div>
          )}
          {options.map((option, index) => (
            <button
              key={index}
              onClick={() => {
                if (multiSelect) {
                  if (option.name === `All ${title}`) {
                    // Check if "All Category" is already selected
                    const allCategorySelected = selected.some(
                      (item) => item.name === `All ${title}`
                    );
                    if (allCategorySelected) {
                      // If "All Category" is already selected, uncheck all options
                      setSelected([]);
                    } else {
                      // When "All Category" is selected, select all options
                      setSelected(options);
                    }
                  } else {
                    setSelected((prevSelected) => {
                      // Create a new array from the current selection
                      let newSelected = [...prevSelected];

                      // Check if the clicked option already exists in the selection
                      const exists = newSelected.some(
                        (item) => item.name === option.name
                      );

                      // Remove "All Category" if it exists in the selection
                      newSelected = newSelected.filter(
                        (item) => item.name !== `All ${title}`
                      );

                      if (exists) {
                        // If option exists, remove it
                        newSelected = newSelected.filter(
                          (item) => item.name !== option.name
                        );
                      } else {
                        // If option doesn't exist, add it
                        newSelected.push(option);
                      }

                      // If all options except "All Category" are selected, add "All Category" too
                      const nonAllCategoryOptions = options.filter(
                        (opt) => opt.name !== `All ${title}`
                      );
                      const allOtherOptionsSelected =
                        nonAllCategoryOptions.every((opt) =>
                          newSelected.some(
                            (selected) => selected.name === opt.name
                          )
                        );

                      if (allOtherOptionsSelected && allCategoryOption) {
                        newSelected.push(allCategoryOption);
                      }

                      return newSelected;
                    });
                  }
                } else {
                  setSelected(option);
                  // Only close dropdown for single select mode
                  setIsOpen(false);
                }
                // Removed setIsOpen(false) here to prevent dropdown from closing after selection
              }}
              className={`inline-flex w-full gap-x-2 mt-1.5 items-center p-4 text-left hover:bg-gray-50 first:rounded-t-2xl last:rounded-b-2xl ${
                (title !== "Sort By" && option === selected) ||
                (title === "Sort By" && option.name === selected.name) ||
                (title !== "Sort By" && multiSelect && checkItemExists(option))
                  ? "text-[#50A85A] font-bold bg-[rgba(80,168,90,0.06)]"
                  : "text-[#525252] font-semibold"
              }
              `}
            >
              {(title !== "Sort By" && option === selected) ||
                (title === "Sort By" && option.name === selected.name) ||
                (title !== "Sort By" && multiSelect && (
                  <div
                    className={`w-6 h-6 flex items-center justify-center rounded-md cursor-pointer transition-colors duration-200 border bg-green-500 border-green-500`}
                    style={{
                      backgroundColor: checkItemExists(option)
                        ? "#50A85A"
                        : "white",
                      borderColor: "#50A85A",
                      borderRadius: "6px",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                ))}
              {option.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
